// constants.js

export const REVIEW_CREATE = 'create';
export const REVIEW_UPDATE = 'update';
export const REVIEW_MERGE  = 'merge';


// Service fields

// Group 1 - Service Information
export const SERVICE_NAME = 'serviceName';
export const DESCRIPTION = 'description';
export const PHONE = 'mainPhone';
export const FAX = 'mainFax';
export const EMAIL = 'mainEmail';
export const OP_HOURS = 'operatingHours';
export const WEBSITE = 'mainWebsite';
export const NATIONWIDE_ACCESS = 'nationwideAccess';

// Group 2 - Location Information
export const ADDRESS_LINE1 = 'addressLine1';
export const CITY = 'city';
export const STATE = 'state';
export const POSTAL_CODE = 'postalCode';
export const COUNTY = 'county';
export const COUNTRY = 'country';

// Group 3 - Additional Information
export const ADDITIONAL_INFO = 'additionalInformation';
export const NECESSARY_DOCS = 'necessaryDocuments';
export const NECESSARY_MATS = 'necessaryMaterials';
export const INSURANCE_ACCEPT = 'insuranceAccepted';        // not used 11/8
export const ACCEPTS_INSURANCE = 'acceptsInsurance';        // new 11/8
export const NEXT_STEPS = 'nextSteps';
export const COST_FREE = 'costFreeText';
export const ELIGIBILITY = 'eligibility';
export const AVAILABILITY = 'availability';
export const LANGUAGES = 'supportedLanguages';
export const REVIEWED = 'reviewed';
export const LAST_VALID = 'lastValidated';

// Group 4 - Social/Online Information
export const FACEBOOK = 'mainFacebook';
export const TWITTER = 'mainTwitter';
export const OTHER_SOCIAL = 'otherSocialMedia';
export const GOOGLE_BUS_LINK = 'googleBusinessLink';
export const GOOGLE_RATING = 'googleRating';
export const GOOGLE_NUM_RATINGS = 'googleNumberRatings';

// Group 5 - Stats
export const ID = 'id';
export const CREATED_AT = 'createdAt';
export const UPDATED_AT = 'updatedAt';
export const LAT = 'lat';
export const LON = 'lon';

// Group 6 - Coverage
export const COVER_AREAS = 'coverageAreas';
export const COVER_COUNTIES = 'coverageCounties';
export const COVER_POSTALS = 'coveragePostalCodes';
export const COVER_GRAN = 'coverageGranularity';
export const LOC_PRECISION = 'locationPrecision';


// CRUD modes
export const CRUD_CREATE = 'crud_create';
export const CRUD_READ = 'crud_read';
export const CRUD_UPDATE = 'crud_update';
export const CRUD_DELETE = 'crud_delete';

